import { BsInfoCircle } from 'react-icons/bs';
import { FaArrowRight } from 'react-icons/fa';
import slate from '../packages/plugins/content/slate';

const defaultSlate = slate();

const furtherInfoPlugin: any = {
  Renderer: ({ children, data }: any) => (
    <div
      className="furtherInfo-content"
      style={{
        display: 'flex',
        background: data?.backgroundColor ? data?.backgroundColor : 'white',
        padding: '0px 11px',
        minWidth: 400,
        maxWidth: '1000px',
        alignItems: 'center',
        margin: '10px',
        border: '1px solid #222',
      }}
    >
      <div
        className="furtherInfo-icon"
        style={{
          fontSize: '22px',

          marginRight: '10px',
        }}
      >
        <BsInfoCircle />
      </div>
      <div
        className="furtherInfo-text"
        style={{ width: '90%', color: '#262d7b', paddingRight: 10, flex: 1 }}
      >
        {children}
      </div>
      <div
        className="further-info-link"
        style={{
          flexShrink: 0,
          marginLeft: '10px',
        }}
      >
        <FaArrowRight size={30} />
      </div>
    </div>
  ),
  createInitialChildren: () => {
    return [
      [
        {
          plugin: defaultSlate,
          data: defaultSlate.createData(({ plugins }) => ({
            children: [
              {
                plugin: plugins.headings.h4,
                children: ['Enter further info text...'],
              },
            ],
          })),
        },
      ],
    ];
  },

  id: 'furtherInfo-plugin',
  title: 'Info Box',
  // description: 'emergency content plugin',
  version: 1,
  controls: {
    type: 'autoform',
    schema: {
      required: ['backgroundColor'],
      properties: {
        backgroundColor: { type: 'string' },
      },
    },
  },
};

export default furtherInfoPlugin;
